import { useQuery } from '@apollo/client'
import { TEST_SESSION_MEMBERS } from './operations'
import { SortDirectionEnum, TestSessionMembers, TestSessionMembersVariables } from '../../types'

const DEFAULT_PAGE_LENGTH = 5

interface UseTestSessionMembersProps {
  testSessionId: string
  userId?: string
  emailOrNameLike?: string
  hasTest?: boolean
  skipTest?: boolean
  onlyPermitted?: boolean
  groupIds?: Array<string>
  companyIds?: Array<string>
  staffOnly?: boolean
  participantOnly?: boolean
  page?: number
  pageLength?: number
  sortBy?: string
  direction?: SortDirectionEnum
}

export const useTestSessionMembers = ({
  testSessionId,
  userId,
  groupIds,
  staffOnly,
  participantOnly,
  emailOrNameLike,
  hasTest,
  onlyPermitted = false,
  page = 1,
  pageLength = DEFAULT_PAGE_LENGTH,
  skipTest,
  sortBy = 'User.email',
  direction = SortDirectionEnum.ASC,
}: UseTestSessionMembersProps) =>
  useQuery<TestSessionMembers, TestSessionMembersVariables>(TEST_SESSION_MEMBERS, {
    variables: {
      id: testSessionId,
      filterData: {
        ...(userId && { userIds: [userId] }),
        groupIds,
        participantOnly,
        staffOnly,
        emailOrNameLike,
        hasTest,
      },
      testFilterData: {
        onlyPermitted,
      },
      pagination: {
        from: page * pageLength - pageLength,
        length: pageLength,
        sortBy,
        direction,
      },
      skipTest: !!skipTest,
    },
  })
